<template>
  <div id="Home">
    <Holding></Holding>
  </div>
</template>

<script>
import Holding from '@/components/HoldingPage.vue'
export default {
  name: 'Grass Home',
  components: {
    Holding
  },
  methods: {
    // isMobile() {
    //     if( screen.width <= 768 ) {
    //         return true;
    //     }
    //     else {
    //         return false;
    //     }
    // },
  }
}
</script>
<style scoped>
  .topbkColor {
    background-color: #FFFFFF;
  }
  .WhatspinposBk {
    background-color: #FFFFFF;
  }
  .HowPinPosWorksBK {
    background-color: #2D2D39;
  }
  .TrustedBK {
    background-color: #FFFFFF;
  }
  .ContactBK {
    background-color: #e6e4e4;
  }
</style>
